import React, { useRef, useEffect } from 'react';
import { useDrop } from 'react-dnd';
import DraggableFormComponent from './DraggableFormComponent';
import './FormCanvas.css';

const FormCanvas = ({
  components,
  moveComponent,
  onRemove,
  onSelectComponent,
  selectedComponent,
  isPreviewMode,
  formTitle,
  formDesc,
  renderFormSettings
}) => {
  const [, drop] = useDrop({
    accept: 'form-component',
  });

  // 画布ref
  const canvasRef = useRef(null);

  // 滚动到底部
  const scrollToBottom = () => {
    if (canvasRef.current) {
      canvasRef.current.scrollTop = canvasRef.current.scrollHeight;
    }
  };

  // 点击控件时自动滚动到底部
  const handleComponentClick = (component) => {
    if (!isPreviewMode) {
      onSelectComponent(component);
      setTimeout(scrollToBottom, 0); // 等待渲染后滚动
    }
  };

  // 添加新控件后自动滚动到底部
  useEffect(() => {
    scrollToBottom();
  }, [components.length]);

  return (
    <div ref={node => { drop(node); canvasRef.current = node; }} className="form-canvas" style={{ overflowY: 'auto', maxHeight: '80vh' }}>
      {renderFormSettings && renderFormSettings()}
      {isPreviewMode && (
        <div className="preview-header">
          <h1 style={{ color: '#333', fontSize: 28, marginBottom: 8 }}>{formTitle || '未命名表单'}</h1>
          {formDesc && (
            <div
              className="form-desc-preview"
              style={{ marginBottom: 24, background: '#f6ffe6', borderRadius: 8, padding: 16 }}
              dangerouslySetInnerHTML={{ __html: formDesc }}
            />
          )}
        </div>
      )}
      
      {components.length === 0 ? (
        <div style={{ color: '#aaa', textAlign: 'center', marginTop: 40 }}>
          {isPreviewMode ? '暂无表单内容' : '请从左侧添加组件'}
        </div>
      ) : (
        <div>
          {components.map((comp, idx) => (
            <DraggableFormComponent
              key={comp.id}
              index={idx}
              id={comp.id}
              type={comp.type}
              data={comp}
              moveComponent={isPreviewMode ? null : moveComponent}
              onSelect={handleComponentClick}
              onRemove={isPreviewMode ? null : onRemove}
              isSelected={selectedComponent?.id === comp.id}
              isPreviewMode={isPreviewMode}
              selectedComponent={selectedComponent}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default FormCanvas; 